import { createSelector } from 'reselect'

import { fetchQuestionSearchPlaceholders } from '../reducers/search'
import { createDataHook } from '../hook-factory'

export const [
  useQuestionSearchPlaceholders,
  useQuestionSearchPlaceholdersLazy,
] = createDataHook(
  fetchQuestionSearchPlaceholders,
  createSelector(
    (state) => state.search.questionSearchPlaceholders,
    (_state, { specialtyId }) => specialtyId,
    (questionSearchPlaceholders, specialtyId) =>
      questionSearchPlaceholders?.[specialtyId] || []
  )
)
